var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechAchi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 346,
    viewBox: "0 0 288 346",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.156 12.9303L196.703 95.3829",
    stroke: "#F8F9FA",
    strokeWidth: 1.83864,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9955 14.6361L94.2812 94.9219",
    stroke: "#F8F9FA",
    strokeWidth: 1.83864,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.401 284.675L251.657 178.406L145.401 72.1377L39.1445 178.406L145.401 284.675Z",
    fill: "url(#paint0_linear_1077_1086)",
    stroke: "#5B5B5B",
    strokeWidth: 1.83864,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M145.994 272.885L242.391 176.477L145.994 80.0683L49.597 176.477L145.994 272.885Z",
    fill: "url(#paint1_linear_1077_1086)",
    stroke: "#5B5B5B",
    strokeWidth: 1.83864,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.983 344.698L252.239 238.43L145.983 132.161L39.7265 238.43L145.983 344.698Z",
    fill: "url(#paint2_linear_1077_1086)",
    stroke: "#5B5B5B",
    strokeWidth: 1.83864,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M145.967 334.838L242.364 238.43L145.967 142.021L49.5697 238.43L145.967 334.838Z",
    fill: "url(#paint3_linear_1077_1086)",
    stroke: "#5B5B5B",
    strokeWidth: 1.83864,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M266.531 165.32L145.753 44.5418",
    stroke: "#F8F9FA",
    strokeWidth: 1.83864,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6334 165.32L145.754 44.5418",
    stroke: "#F8F9FA",
    strokeWidth: 1.83864,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M270.014 12.1875C270.014 10.2607 270.541 8.37625 271.529 6.77416C272.518 5.17207 273.922 3.92385 275.565 3.18649C277.209 2.44913 279.017 2.25593 280.761 2.63184C282.506 3.00774 284.108 3.9361 285.366 5.29856C286.624 6.66103 287.48 8.39687 287.827 10.2867C288.174 12.1765 287.996 14.1349 287.315 15.915C286.635 17.6952 285.482 19.2171 284.003 20.2876C282.524 21.3581 280.786 21.9297 279.007 21.9297C276.622 21.9297 274.334 20.9025 272.648 19.0755C270.961 17.2485 270.014 14.7713 270.014 12.1875Z",
    fill: "#F8F9FA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0618954 10.4453C0.0618954 8.51852 0.633282 6.63406 1.7038 5.03197C2.77432 3.42988 4.29582 2.18167 6.07603 1.4443C7.85623 0.706944 9.81522 0.513744 11.7051 0.889648C13.5949 1.26555 15.3308 2.19391 16.6933 3.55637C18.0559 4.91884 18.9838 6.65468 19.3597 8.54448C19.7356 10.4343 19.5426 12.3927 18.8052 14.1729C18.0679 15.953 16.8191 17.4749 15.217 18.5454C13.6148 19.6159 11.7313 20.1875 9.80438 20.1875C7.22052 20.1875 4.7425 19.1604 2.91543 17.3334C1.08836 15.5063 0.0618954 13.0291 0.0618954 10.4453Z",
    fill: "#F8F9FA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M121.7 248.945V226.242H125.407V248.945H121.7ZM128.962 248.945V247.125L141.935 229.419H129.822V226.242H147.429V228.062L134.39 245.768H147.727V248.945H128.962ZM151.459 248.945V226.242H155.166V237.56L165.988 226.242H170.555L161.818 235.376L170.787 248.945H166.418L159.303 237.991L155.166 241.797V248.945H151.459Z",
    fill: "#0A1214"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1077_1086",
    x1: 150.556,
    y1: 73.8751,
    x2: 144.462,
    y2: 286.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.467477,
    stopColor: "#34DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6FFE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1077_1086",
    x1: 146.557,
    y1: 112.861,
    x2: 145.807,
    y2: 280.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.467477,
    stopColor: "#34DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6FFE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1077_1086",
    x1: 145.412,
    y1: 131.08,
    x2: 144.449,
    y2: 345.889,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.467477,
    stopColor: "#34DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6FFE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1077_1086",
    x1: 145.414,
    y1: 143.077,
    x2: 144.551,
    y2: 335.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.467477,
    stopColor: "#34DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6FFE5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechAchi);
export default __webpack_public_path__ + "static/media/techAchi.74785b06cc9504f9cffa7bbb47106b6f.svg";
export { ForwardRef as ReactComponent };